import React, { useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import {
  IconButton,
  Typography,
  Grid,
  TextField,
  Paper,
  InputAdornment,
  Button
} from '@material-ui/core'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'
import LoadingButton from '../components/LoadingButton'
import DateInput from '../components/DateInput'
import {
    usePoreceiptsReactTableCols
} from '../constants/PoCols'
import { smallScreenWidth } from '../constants/AppConstants'
import ReactTable from '../components/ReactTable'
import fetchFromAthena from '../functions/FetchFromAthena'
import OpenSearchDropdown from '../components/OpenSearchDropdown'


const _ = require('lodash')

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    margin: '2rem 1rem'
  },
  treeRoot: {
    flexGrow: 1,
    margin: '1rem'
  }
}))

const startAdornment = (
  <>
    <InputAdornment position='start'>
      <div></div>
    </InputAdornment>
  </>
)
const defaultHeaders = {
  company: '',
  fromDate: '',
  toDate: '',
  poCode: '',
  poNumber: '',
  poRelease: '',
}

export default function PoReceipt (props) {
  const [state, setstate] = useState({
    isLoading: false,
    data: null,
    fetched: true,
    tableKey: JSON.stringify(defaultHeaders)
  })
  const [showTable, setShowTable] = useState(false)
  const [headers, setHeaders] = useState(defaultHeaders)
  const [clearHeader, setClearHeaders] = React.useState(false)
  const [clearTrigger, setClearTrigger] = React.useState(false)

  const classes = useStyles()
  const poreceiptsReactTableCols = usePoreceiptsReactTableCols()

  const { credentials } = props.fetchInitialData

  const handleSubmit = async e => {
    e.preventDefault()
    try {
        setstate({ ...state, isLoading: true })

        const receiptData = await fetchFromAthena({
          queryName: 'po_receipt_inquiry',
          headers,
          accessToken: credentials.user.accessToken,
          credentials: credentials
        })
  
        setstate({
          ...state,
          data: receiptData,
          isLoading: false
        })

        // const resp = await LambdaFetch(
        //   'po-inquiry',
        //   'post',
        //   credentials.user.accessToken,
        //   JSON.stringify({
        //     action: 'po-receipt',
        //     ...headers
        //   }),
        //   '',
        //   credentials
        // )
        // setstate({
        //   ...state,
        //   data: receiptData,
        //   isLoading: false
        // })
      } catch (e) {
        console.log(e)
      }
  }

  return (
    <div style={{ padding: '1.5rem 0.5rem' }}>
      <IconButton
        style={{ borderRadius: '5px', position: 'absolute' }}
        size='small'
        onClick={() => props.history.push('/')}
        aria-label='delete'
      >
        <ArrowBackIcon />
        {props.fetchInitialData.credentials.appWidth > smallScreenWidth &&
          'Dashboard'}
      </IconButton>
      <Typography variant='h5' style={{ textAlign: 'center' }}>
        Purchase Order Receipt
      </Typography>
      <div className={classes.root}>
        <Paper elevation={0} style={{ padding: '1rem' }}>
          <form onSubmit={handleSubmit}>
            <Grid
              container
              alignContent='center'
              alignItems='flex-start'
              spacing={3}
            >
              <Grid item>
                <OpenSearchDropdown
                  id='company'
                  required
                  width='250px'
                  label='Company'
                  page="PO"
                  entity="COMPANY"
                  searchFields={['DISPLAY']}
                  accessToken={credentials.user.accessToken}
                  credentials={credentials}
                  clearTrigger={clearTrigger}
                  onChange={(val) => {
                    setHeaders({ ...headers, company: val?.VALUE || '' })
                  }}
                />
              </Grid>
              <Grid item>
                <OpenSearchDropdown
                  id='poNumber'
                  required
                  disabled={!headers.company}
                  width='250px'
                  label='PO Number'
                  page="PO"
                  entity="PONUM"
                  searchFields={['DISPLAY']}
                  accessToken={credentials.user.accessToken}
                  credentials={credentials}
                  clearTrigger={clearTrigger}
                  filters={{
                    COMPANY: headers.company
                  }}
                  onChange={(val) => {
                    setHeaders({ ...headers, poNumber: val?.VALUE || '', poCode: val?.POCODE || '' })
                  }}
                />
              </Grid>

              <Grid item>
                <TextField
                  id='poRelease'
                  label='Release'
                  key={clearHeader}
                  style={{ width: '125px', paddingTop: '8px' }}
                  variant='standard'
                  value={headers.poRelease}
                  onChange={e =>
                    setHeaders({ ...headers, poRelease: e.target.value })
                  }
                />
              </Grid>
              <Grid item>
                <TextField
                  id='poCode'
                  label='PO Code'
                  key={clearHeader}
                  style={{ width: '125px', paddingTop: '8px' }}
                  variant='standard'
                  value={headers.poCode}
                  InputProps={{ readOnly: true }}
                />
              </Grid>

              {[
                {
                  id: 'fromDate',
                  label: 'From Date'
                },
                {
                  id: 'toDate',
                  label: 'To Date'
                }
              ].map(field => {
                return (
                  <Grid key={field.id} item>
                    <DateInput
                      id={field.id}
                      key={clearHeader}
                      type={'date'}
                      required={true}
                      label={field.label}
                      value={headers[field.id]}
                      onChange={e => {
                        setHeaders({
                          ...headers,
                          [field.id]: !!e.target.value ? e.target.value : null
                        })
                      }}
                      variant='standard'
                      width='160px'
                    />
                  </Grid>
                )
              })}
            </Grid>

            <div style={{ marginTop: '1rem' }}>
              <LoadingButton
                label="Submit"
                isLoading={state.isLoading}
                color="primaryVLButton"
                buttonType="submit"
              />
              {!!(
                headers.company || 
                headers.fromDate || 
                headers.toDate || 
                headers.poCode || 
                headers.poNumber || 
                headers.poRelease
              ) && (
                <Button
                  onClick={() => {
                    setClearHeaders(!clearHeader);
                    setHeaders(defaultHeaders);
                    setClearTrigger(prev => !prev);
                    setstate({
                      ...state,
                      data: null
                    });
                  }}
                  style={{ marginLeft: '0.5rem' }}
                >
                  Clear
                </Button>
              )}
            </div>

        
          </form>
        </Paper>
        {state.data && (
          <Grid
            item
            xs={12}
            style={{ position: 'relative', marginTop: '1rem' }}
          >
            <ReactTable cols={poreceiptsReactTableCols} data={state.data} />
          </Grid>
        )}
      </div>
    </div>
  )
}
